import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { get } from '../utils/api';
import { usePortalProfile } from './PortalProfileContext';

const PortalPoshakaContext = createContext(null);

const defaultState = () => ({
  year: new Date().getFullYear(),
  isSubscriber: false,
  ribbon: null,
});

export function PortalPoshakaProvider({ children }) {
  const { detailsLoading } = usePortalProfile();
  const [poshaka, setPoshaka] = useState(defaultState);

  const refreshPoshaka = useCallback(async () => {
    try {
      const d = await get('/portal/me/poshaka-ribbon');
      setPoshaka({
        year: d?.year ?? new Date().getFullYear(),
        isSubscriber: !!d?.isSubscriber,
        ribbon: d?.ribbon || null,
      });
    } catch {
      setPoshaka(defaultState());
    }
  }, []);

  useEffect(() => {
    if (detailsLoading) return;
    refreshPoshaka();
  }, [detailsLoading, refreshPoshaka]);

  const value = useMemo(() => ({ poshaka, refreshPoshaka }), [poshaka, refreshPoshaka]);

  return (
    <PortalPoshakaContext.Provider value={value}>
      {children}
    </PortalPoshakaContext.Provider>
  );
}

export function usePortalPoshaka() {
  const ctx = useContext(PortalPoshakaContext);
  if (!ctx) throw new Error('usePortalPoshaka must be used within PortalPoshakaProvider');
  return ctx;
}
